module.exports = __webpack_public_path__ + "5ae415e0f3939ed7df854d2c50a582dd.jpg";